module.exports = __webpack_public_path__ + "img/1572402637.841b8796.jpg";